/* Dansk katalog for locale-payroll-runs-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'pay.overview': 'Lønoversigt',
  'pay.overviewSub': 'Registreret løn for regnskabsåret, grupperet pr. medarbejder.',
  'pay.noPayBasis': 'Intet løngrundlag endnu',
  'pay.noPayBasisHint': 'Når lønkørsler er godkendt eller udbetalt, vises oversigten her.',
  'pay.noPeriodsHint': 'Arbejdsgiverafgift og skattetræk vises, når du har godkendte lønkørsler.',
  'pay.noOtpBasisHint': 'Pensionsgrundlag vises, når du har lønkørsler med pensionsbeløb.',
  'pay.noHolidayPayHint': 'Feriepengegrundlag vises, når du har godkendte lønkørsler i den valgte periode.',
  'pay.noPayslipsHint': 'Lønsedler vises, når lønudbetalingen har medarbejdere.',
  'pay.noInboxVouchersHint': 'Bilag, der endnu ikke er bogført, vises her.',
  'pay.noEntriesHint': 'Regnskabsbilag vises, efter at lønudbetalingen er godkendt.',
  'pay.noFixedLinesHint': 'Tilføj faste lønlinjer på medarbejdere for at bruge dem i lønkørsel.',
  'pay.salaryTypeSearchHintFull': 'Almindelige typer vises først. Søg, eller vælg Vis flere for hele det aktive katalog.',
  'pay.overrideReasonSavedOnLineHint': 'Gemmes på lønlinjen som revisionsspor.',
  'pay.salaryTypeSearchHintRest': 'Almindelige typer vises først. Søg, eller vælg Vis flere for resten.',
  'pay.overrideReasonSavedOnFixedLineHint': 'Gemmes på den faste linje.',
  'pay.payPeriodMonthOnlyHint': 'Lønkørsler understøtter indtil videre kun månedsperioder.',
  'pay.calculationCodeOtherHint': 'Andre beregningskoder bliver tilgængelige, når de er implementeret og kontrolleret.',
  'pay.runsAndEmployeesInline': '{{runs}} lønk. · {{employees}} medarbejdere',
  'pay.fteShort': 'Årsværk:',
  'pay.taxShort': 'Skat:',
  'pay.netShort': 'Netto:',
  'pay.holidayPayShort': 'Feriep.:',
  'pay.agaShort': 'AGA:',
  'pay.withholdingHelp': 'Skattetræk — den skat, der trækkes fra bruttolønnen og betales til staten på medarbejderens vegne.',
  'pay.holidayPayHelp': 'Optjente feriepenge — normalt 10,2 % af løngrundlaget. Udbetales året efter, at de er optjent.',
  'pay.aga': 'AGA',
  'pay.agaHelp': 'Arbejdsgiverafgift af lønnen — afgift, som arbejdsgiveren betaler til staten ud over lønomkostningen.',
  'pay.fpShort': 'FP:',
  'pay.agaOfHolidayPay': 'AGA af fp.',
  'pay.agaOfHolidayPayHelp': 'Arbejdsgiverafgift beregnet af de optjente feriepenge. Hensættes, når feriepengene optjenes.',
  'pay.fte': 'Årsværk',
  'pay.fteHelp': 'Stillingsandel omregnet til hele årsværk. 1,00 = fuld stilling, 0,50 = halv stilling.',
  'pay.overviewFilteredSub': 'Registreret løn for regnskabsåret, filtreret på udbetalingsdato.',
  'pay.grouping': 'Gruppering',
  'pay.perEmployee': 'Pr. medarbejder',
  'pay.perSalaryType': 'Pr. løntype',
  'pay.employeeAndType': 'Medarbejder og løntype',
  'pay.againstWithholding': 'Mod skattetræk',
  'pay.againstAga': 'Mod AGA',
  'pay.postedAs': 'Posteres sådan:',
  'pay.postedWithholdingOnly': '{{tax}} mod 2600 skattetræk. Åbent før betaling: {{openTax}}.',
  'pay.postedAgaOnly': '{{aga}} mod 2770 arbejdsgiverafgift. Åbent før betaling: {{openAga}}.',
  'pay.postedBoth': '{{tax}} mod 2600 skattetræk og {{aga}} mod 2770 arbejdsgiverafgift. Åbent før betaling: {{openTax}} skat og {{openAga}} AGA.',
  'pay.autoPostedAgainstWithholding': 'Betalingen posteres automatisk mod 2600 skattetræk og krediterer den valgte afregningskonto.',
  'pay.autoPostedAgainstAga': 'Betalingen posteres automatisk mod 2770 arbejdsgiverafgift og krediterer den valgte afregningskonto.',
  'pay.autoPostedAgainstBoth': 'Betalingen posteres automatisk mod 2600 skattetræk og 2770 arbejdsgiverafgift og krediterer den valgte afregningskonto.',
  'pay.agreedAnnualSalary': 'Aftalt årsløn',
  'pay.agreedHourlyPay': 'Aftalt timeløn',
  'pay.withholdingSeparatePaymentNote': 'Skattetræk for løn udbetalt fra 2026 betales separat senest første hverdag efter lønudbetalingen.',
  'pay.recommendedForOtpPayment': 'Anbefalet til OTP-betaling',
  'pay.otpPaymentPostingNote': 'Betalingen bogføres mod den valgte afregningskonto og bruges af oversigten Pension/OTP. Banklinjen kan derefter matches mod betalingsbilaget.',
  'pay.holidayPayAccruedLastYear': 'Feriepenge, optjent sidste år',
  'pay.holidayPayAccruedThisYear': 'Feriepenge, optjent i år',
  'pay.ordinaryEmployment': 'Almindeligt ansættelsesforhold',
  'pay.payslipUncheckAllNote': 'Fjern fluebenet for alle medarbejdere, hvis lønsedlerne skal sendes senere. De kan sendes fra lønkørslen, efter at bogføringen er godkendt.',
  'pay.payslipPdfNotConnected': 'Lønseddel-PDF er ikke koblet til backend.',
  'pay.noSalaryLines': 'Ingen lønlinjer',
  'pay.deletedOn': 'Slettet {{date}}',
  'pay.payrollPaymentOn': 'Lønudbetaling {{date}}',
  'pay.readyLinesForPayroll': '{{count}} godkendte linjer klar til løn ({{amount}}).',
  'pay.noReadyLinesForPayroll': 'Ingen godkendte linjer klar til løn.',
  'pay.overrideAppliesFutureRuns': 'Tilsidesættelsen gælder fremtidige lønkørsler, der bruger denne faste linje.',
  'pay.sentToLabel': 'sendes til',
  'pay.recommendedForPayrollPayment': 'Anbefalet til lønudbetaling',
  'pay.optionalNotePh': 'Valgfri note ...',
  'pay.openWithholding': 'Åbent skattetræk',
  'pay.openAga': 'Åben arbejdsgiverafgift',
  'pay.noPeriodPayments': 'Ingen betalinger registreret på terminen endnu.',
  'pay.advance': 'Forskud',
  'pay.agaAndWithholding': 'Arbejdsgiverafgift og skattetræk',
  'pay.agaAndWithholdingSub': 'Følg op på skattetræk og arbejdsgiverafgift fra godkendte lønkørsler pr. termin.',
  'pay.withholdingLongHelp': 'Den skat, du har trukket fra medarbejdernes løn. Den holdes tilbage på skattetrækskontoen og betales videre til staten — den er ikke din at bruge.',
  'pay.agaLongHelp': 'Afgift, som arbejdsgiveren betaler til staten af løn og ydelser. Satsen afhænger af, hvilken zone (kommune) virksomheden ligger i — 14,1 % i zone 1.',
  'pay.toAuthority': 'Til Skatteetaten',
  'pay.toAuthorityHelp': 'Skattetræk plus arbejdsgiverafgift — det samlede beløb, der skal betales til staten for terminen.',
  'pay.noPeriods': 'Ingen terminer endnu',
  'pay.period2': 'Termin',
  'pay.payrollRunShort': 'Lønk.',
  'pay.pensionOtp': 'Pension / OTP',
  'pay.pensionOtpHelp': 'Obligatorisk tjenestepension (OTP) er lovpligtig opsparing til medarbejdernes pension — mindst 2 % af lønnen. Her registrerer og følger du op på indbetalingerne til pensionsleverandøren fra godkendte lønkørsler.',
  'pay.pensionPayments': 'Pensionsindbetalinger',
  'pay.pensionPaymentsSub': 'Registrér og hold styr på OTP-betalingerne fra godkendte lønkørsler.',
  'pay.newPensionPayment': 'Ny pensionsindbetaling',
  'pay.calculatedOtp': 'Beregnet OTP',
  'pay.calculatedOtpHelp': 'Samlet beregnet obligatorisk tjenestepension for året, fra godkendte lønkørsler.',
  'pay.open2': 'Åbent',
  'pay.unpaid': 'Ubetalt',
  'pay.unpaidOtpHelp': 'OTP, der er beregnet, men endnu ikke betalt til pensionsleverandøren.',
  'pay.otp': 'OTP',
  'pay.paidOtpHelp': 'OTP, der allerede er indbetalt til pensionsleverandøren.',
  'pay.otpPaidWithDifference': 'Betalt {{paid}} · difference {{difference}}',
  'pay.noOtpBasis': 'Intet OTP-grundlag endnu',
  'pay.payPeriod': 'Lønperiode',
  'pay.pensionPayment': 'Pensionsindbetaling',
  'pay.otpRefPh': 'F.eks. OTP-06',
  'pay.holidayPayList': 'Feriepengeliste',
  'pay.holidayPayListSub': 'Optjente og udbetalte feriepenge fra godkendte lønkørsler.',
  'pay.holidayPayBasis': 'Feriepengegrundlag',
  'pay.earned': 'Optjent',
  'pay.noHolidayPay': 'Ingen feriepenge endnu',
  'pay.paymentDate': 'Udbetalingsdato',
  'pay.holidayPayBasisHelp': 'Summen af løn, der giver ret til feriepenge. Feriepengene beregnes som en procentdel af dette grundlag.',
  'pay.holidayPayEarnedHelp': 'Feriepenge optjent indtil nu — normalt 10,2 % af grundlaget (12 % ved fem ugers ferie). Udbetales året efter optjeningen.',
  'pay.holidayPayPaidHelp': 'Feriepenge, der allerede er udbetalt til medarbejdere i år.',
  'pay.voucherShort': 'Bilag:',
  'pay.paidOutShort': 'Udbet.:',
  'pay.earnedShort': 'Optjent:',
  'pay.paidShort': 'Udbetalt:',
  'pay.salaryLine': 'Lønlinje',
  'pay.newLine': 'Opret ny linje',
  'pay.taxResidentCountry': 'Skattemæssigt bosat i land',
  'pay.earningCountry': 'Optjeningsland',
  'pay.earningRelation': 'Indtjeningsforhold',
  'pay.noPrefill': 'Lad ikke beløb/antal være forudfyldt for denne linje i nye lønudbetalinger',
  'pay.holidayPayPayout': 'Udbetaling af feriepenge',
  'pay.addHolidayPay': 'Tilføj feriepenge',
  'pay.earnedEarlier': 'Optjent tidligere',
  'pay.earnedThisYear': 'Optjent i år',
  'pay.pensionContribution': 'Tilskud/præmie til pension',
  'pay.registerPensionContribution': 'Registrér tilskud/præmie til pension',
  'pay.fetchNavRefunds': 'Hent refusioner fra NAV',
  'pay.fetchNavRefundsSub': 'Hent refusioner, der skal medtages i lønudbetalingen.',
  'pay.emailPayslips': 'Send lønsedler via e-mail',
  'pay.sendPayslips': 'Send lønsedler',
  'pay.sendLater': 'Send senere',
  'pay.sendPayslip': 'Send lønseddel',
  'pay.sendAllPayslips': 'Send til alle',
  'pay.sending': 'Sender ...',
  'pay.payslipSendFailed': 'Kunne ikke sende lønseddel.',
  'pay.payslipSendUnavailable': 'Udsendelse af lønsedler er ikke koblet til backend.',
  'pay.downloadPayslip': 'Download lønseddel',
  'pay.downloadAllPdf': 'Download alle (PDF)',
  'pay.downloading': 'Downloader ...',
  'pay.sendTime': 'Tidspunkt for udsendelse',
  'pay.payslipsAfterPosting': 'Lønsedler kan downloades, når lønudbetalingen er bogført.',
  'pay.noPayslipsShort': 'Ingen lønsedler',
  'pay.paymentInfo': 'Information om udbetaling',
  'pay.copyToClipboard': 'Kopiér til udklipsholder',
  'pay.downloadExcel': 'Download Excel',
  'pay.registerPayment': 'Registrér udbetaling',
  'pay.paymentsFromOperating': 'Udbetalinger fra driftskonto:',
  'pay.toBankAccount': 'Til bankkonto',
  'pay.paidOutDate': 'Udbetalingsdato',
  'pay.bankTip': 'Tip! Glem ikke at foretage selve udbetalingen af skattetræk og løn i netbanken.',
  'pay.linkVoucher': 'Knyt bilag',
  'pay.noInboxVouchers': 'Ingen bilag i indbakken',
  'pay.newSalaryLine': 'Ny lønlinje',
  'pay.paidOutVerb': 'Udbetales',
  'pay.agaShort2': 'Arb.afg.',
  'pay.holiday': 'Ferie',
  'pay.noExtraLines': 'Der er endnu ikke tilføjet ekstra lønlinjer.',
  'pay.showEmployeePage': 'Vis medarbejderside',
  'pay.addSalaryLine': 'Tilføj lønlinje',
  'pay.noEmployeesInRun': 'Ingen medarbejdere i lønudbetalingen',
  'pay.holidayPensionDeductions': 'Feriepenge, pension og fradrag',
  'pay.pensionContributionOrPremium': 'Tilskud eller præmie til pension',
  'pay.summary': 'Oversigt',
  'pay.payrollRun': 'Lønudbetaling',
  'pay.agaRate': 'Arb.afgift (14,1 %)',
  'pay.posting': 'Bogføring',
  'pay.writeComment': 'Skriv en kommentar',
  'pay.seePayslips': 'Se lønsedler',
  'pay.nextStep': 'Næste trin',
  'pay.sendAmeldingToAltinn': 'Send A-melding til Altinn',
  'pay.deletePayrollRun': 'Slet lønudbetaling',
  'pay.manualSubmission': 'Manuel indsendelse',
  'pay.sendAmelding': 'Send A-melding',
  'pay.altinnConfirmation': 'Bekræftelse fra Altinn',
  'pay.altinnConfirmationHelp': 'Når A-meldingen er sendt, venter du på bekræftelse, før lønsedlerne oprettes.',
  'pay.createPayslips': 'Opret lønsedler',
  'pay.editPayrollRun': 'Redigér lønudbetaling',
  'pay.registerPaymentToEmployees': 'Registrér betaling til medarbejdere og skat',
  'pay.cancelPosting': 'Annuller bogføringen',
  'pay.cancelPostingConfirmTitle': 'Annuller bogføringen?',
  'pay.cancelPostingConfirmMessage': 'Dette sender lønudbetalingen tilbage til kladde. Registrerede udbetalinger og selve bogføringen annulleres og fjernes fra aktive regnskabstal. Du skal kontrollere og godkende lønnen igen.',
  'pay.cancelPostingConfirmAction': 'Annuller bogføringen',
  'pay.keepPosting': 'Behold bogføringen',
  'pay.seeAccountingVoucher': 'Se regnskabsbilag',
  'pay.registerPayments': 'Registrér udbetalinger',
  'pay.payrollDone': 'Lønnen er kørt og bogført!',
  'pay.payrollDoneSub': 'Lønudbetalingen er indsendt, bogført og registreret som udbetalt.',
  'pay.allPayrollRuns': 'Alle lønudbetalinger',
  'pay.noEntries': 'Ingen posteringer',
  'pay.calculatedWithholding': 'Beregnet skattetræk',
  'pay.toPayOut': 'Til udbetaling',
  'pay.activePayrollRuns': 'Aktive lønudbetalinger',
  'pay.runsCount': '{{count}} kørsler',
  'pay.employeesInActiveRuns': '{{count}} medarbejdere i aktive kørsler',
  'pay.createNewRunHint': 'Opret en ny lønudbetaling for at hente medarbejdere, faste lønlinjer og godkendte rejser ind.',
  'pay.activePayrollRunsHelp': 'En lønudbetaling beregner løn, skattetræk, feriepenge og arbejdsgiverafgift for en periode. Aktive kørsler er under arbejde.',
  'pay.newPayrollRun': 'Ny lønudbetaling',
  'pay.noActiveRuns': 'Ingen aktive lønudbetalinger',
  'pay.earlierPayrollRuns': 'Tidligere lønudbetalinger',
  'pay.earlierPayrollRunsHelp': 'Lønkørsler, hvor udbetalingen er registreret. Du kan åbne dem for detaljer, lønsedler og regnskabsbilag.',
  'pay.orderNumberDate': 'Nyeste udbetaling først',
  'pay.travelAndExpenses': 'Rejser og udlæg',
  'pay.createPayrollRun': 'Opret ny lønudbetaling',
  'pay.payrollRunDate': 'Dato for lønudbetaling',
  'pay.payPeriodMonthHelp': 'Den måned, lønnen gælder for. Udbetalingsdatoen kan være en separat dato.',
  'pay.paymentDateHelp': 'Den dato, pengene faktisk udbetales. Den ændrer ikke lønperioden.',
  'pay.paymentDatePeriodWarning': 'Udbetalingsdatoen ligger uden for den normale måned for lønperioden. Kontrollér, at lønperioden og datoen er korrekte.',
  'pay.includeFixedLines': 'Medtag faste lønlinjer',
  'pay.includeExpenseLines': 'Medtag linjer for udlæg',
  'pay.readyExpenseLineCount': '{count} linjer klar til udbetaling',
  'pay.payPeriodLength': 'Lønperiode (optjeningslængde)',
  'pay.ordinaryWithholding': 'Almindeligt skattetræk',
  'pay.useTaxCard': 'Brug skattekort, når det er tilgængeligt',
  'pay.optionalComment': 'Valgfri kommentar',
  'pay.salaryTypesAndDeductions': 'Lønarter og træk',
  'pay.salaryTypesHelp': 'Lønarter styrer, hvordan en lønlinje behandles for arbejdsgiverafgift, skattetræk, feriepenge og pension.',
  'pay.newSalaryType': 'Ny lønart',
  'pay.agaLiableHelp': 'Om lønarten indgår i grundlaget for arbejdsgiverafgift. Afkrydset = afgiftspligtig.',
  'pay.withholdingLiableHelp': 'Om lønarten er trækpligtig — altså om der skal trækkes forskudsskat af beløbet.',
  'pay.holidayPayLiableHelp': 'Om lønarten giver feriepengegrundlag — altså om der optjenes feriepenge af beløbet.',
  'pay.pension': 'Pension',
  'pay.pensionLiableHelp': 'Om lønarten indgår i grundlaget for obligatorisk tjenestepension (OTP).',
  'pay.rules': 'Regler',
  'pay.noLiabilityRules': 'Ingen afgifts- eller trækpligtige regler',
  'pay.noEffect': 'Ingen påvirkning',
  'pay.bonusExamplePh': 'F.eks. Bonus uden feriepenge',
  'pay.benefitInKind': 'Naturalieydelse',
  'pay.deduction': 'Træk',
  'pay.taxFreeAllowance': 'Skattefri godtgørelse',
  'pay.overrideNote': 'Ændringer gemmes som virksomhedens tilsidesættelse af standardtypen.',
  'pay.ratePerMonth': 'Sats (pr. måned)',
  'pay.calculated': 'Beregnes',
  'pay.changeCountries': 'Ændr optjeningsland/bosat i land',
  'pay.optionalCommentPh': 'Valgfri kommentar ...',
  'pay.fixedSalaryLines': 'Faste lønlinjer',
  'pay.fixedSalaryLinesSub': 'Lønlinjer, der gentages automatisk ved hver lønkørsel.',
  'pay.addFixedLine': 'Tilføj fast lønlinje',
  'pay.noFixedLines': 'Ingen faste lønlinjer',
  'pay.payrollSettings': 'Lønindstillinger',
  'pay.payrollSettingsSub': 'Standardvalg, der bruges, når Plumme bogfører løn, arbejdsgiverafgift, feriepenge og pension.',
  'pay.contributionAndHoliday': 'Afgift og feriepenge',
  'pay.agaZone': 'Zone for arbejdsgiverafgift',
  'pay.holidayPayRate': 'Feriepengesats',
  'pay.pensionOtpShort': 'Pension (OTP)',
  'pay.pensionProvider': 'Pensionsudbyder',
  'pay.providerOrgNo': 'Org.nr. udbyder',
  'pay.otpRate': 'OTP-sats',
  'pay.accountsAndReporting': 'Konti og indberetning',
  'pay.payrollAccount': 'Lønkonto (bank)',
  'pay.withholdingAccount': 'Skattetrækskonto',
  'pay.firstPayrollYear': 'Første år for lønbogføring',
  'pay.entityNumber': 'Virksomhedsnummer',
  'pay.holidayPayPercent': 'Procent feriepenge',
  'pay.holidayPayPercentHelp': 'Den sats, feriepenge optjenes med. 10,2 % er lovens minimum; 12 % gælder ved aftale om fem ugers ferie.',
  'pay.holidayPayMonth': 'Måned for feriepenge',
  'pay.month.january': 'Januar',
  'pay.month.february': 'Februar',
  'pay.month.march': 'Marts',
  'pay.month.april': 'April',
  'pay.month.june': 'Juni',
  'pay.month.july': 'Juli',
  'pay.month.august': 'August',
  'pay.month.september': 'September',
  'pay.month.october': 'Oktober',
  'pay.month.november': 'November',
  'pay.month.december': 'December',
  'pay.shift.none': 'Ikke skift',
  'pay.shift.shift': 'Skift',
  'pay.shift.rota': 'Turnus',
  'pay.shift.continuous': 'Døgnkontinuerligt skift',
  'pay.ordinary': 'Almindelig',
  'pay.maritime': 'Maritim',
  'pay.freelancer': 'Freelancer',
  'pay.pensionOrOtherBenefit': 'Pension eller anden ydelse',
  'pay.municipalityAndNumber': 'Kommune og kommunenummer',
  'pay.pickMunicipality': 'Vælg kommune',
  'pay.calculationCode': 'Beregningskode',
  'pay.generalIndustries': 'Generelle erhverv',
  'pay.agricultureForestry': 'Landbrug og skovbrug',
  'pay.fishing': 'Fiskeri og fangst',
  'pay.pensionProviderOtp': 'Pensionsudbyder (OTP)',
  'pay.withholdingAccounts': 'Trækkonti',
  'pay.payoutAccount': 'Konto for lønudbetaling',
  'pay.amelding': 'A-melding',
  'pay.everyMonth': 'Hver måned',
  'pay.everyPayrollRun': 'Ved hver lønkørsel',
  'pay.taxCardChangeAlert': 'Besked ved ændring af skattekort',
  'pay.emailPh': 'navn@firma.no',
  'pay.sms': 'SMS',
  'pay.savingsAccount': 'Opsparingskonto',
  'pay.withholdingMode.fiftyPercent': '50 % forskudstræk',
  'pay.withholdingMode.standardHint': 'Bruger det gyldige skattekort, der er registreret på medarbejderen. Mangler det, trækkes 50 %.',
  'pay.withholdingMode.taxCardHint': 'Skattekort hentes endnu ikke automatisk fra Skatteetaten. Plumme bruger det skattekort, der er registreret på medarbejderen, og trækker 50 %, når et gyldigt skattekort mangler.',
  'pay.withholdingMode.fiftyPercentHint': 'Trækker 50 % af trækgrundlaget for alle medarbejdere i denne lønkørsel uanset skattekort.',
  'pay.holidayPayPrevious.hint': 'Optjent sidste år er beregnet ud fra godkendte lønkørsler sidste år minus det, der allerede er udbetalt. Feriepenge optjent, før du begyndte at bruge Plumme, er ikke med – justér beløbet med blyanten.',
  'pay.deductionAccount.label': 'Konto, trækket krediteres',
  'pay.deductionAccount.hint': 'Træk, der betales videre til andre, er gæld. Vælg 2610 for udlægstræk. Plumme indberetter ikke udlægstræk i a-meldingen – trækket skal betales videre separat.',
  'pay.deductionAccount.canteen': '5919 Træk kantineudgifter medarbejdere',
  'pay.deductionAccount.garnishment': '2610 Udlægstræk',
  'pay.deductionAccount.unionDues': '2650 Trukket fagforeningskontingent',
  'pay.deductionAccount.other': '2690 Andre træk',
  'pay.taxRuleUnsupportedError': 'Plumme understøtter ikke {rule} endnu – kør lønnen for {employee} uden for Plumme.',
  'err.payroll.unsupportedTaxRule': 'En medarbejder i lønkørslen har en skatte- og afgiftsregel, som Plumme ikke understøtter endnu. Kør lønnen for denne medarbejder uden for Plumme.',
  'pay.taxRules.svalbard': 'Svalbard',
  'pay.taxRules.janMayen': 'Jan Mayen og bilandene',
  'pay.taxRules.seafarerDeduction': 'særligt fradrag for søfolk',
  'pay.taxRules.charity': 'velgørende eller almennyttig organisation',
  'pay.taxRules.netPay': 'nettoløn',
  'pay.taxRules.netPaySeafarer': 'nettoløn for søfolk',
  'pay.taxRules.pensionSourceTax': 'kildeskat på pensioner',
  'pay.taxRules.nanny': 'dagplejer i barnets hjem',
  'pay.taxRules.homeWork': 'lønarbejde i hjemmet',
  'pay.taxRules.taxFreeOrganization': 'skattefri organisation',
  'pay.pensionAllocation.explain': 'Præmien erstatter beregnet OTP for de medarbejdere, du vælger. Vælger du flere, fordeles beløbet efter deres OTP-grundlag.',
  'pay.pensionAllocation.employees': 'Medarbejdere, præmien gælder',
  'pay.pensionAllocation.amountRequired': 'Angiv et beløb større end 0.',
  'pay.pensionAllocation.noEmployees': 'Vælg mindst én medarbejder, præmien gælder.',
  'pay.pensionAllocation.noBasis': 'De valgte medarbejdere har intet OTP-grundlag i denne lønkørsel. Vælg én medarbejder, eller indtast løn først.',
  'pay.pensionAllocation.noLines': 'Lønkørslen har ingen medarbejdere at knytte pensionspræmien til.',
  'pay.pensionAllocation.saveFailed': 'Kunne ikke registrere pensionspræmien.',
  'pay.travelNotPayableError': 'Disse rejseafregninger eller udlæg kan ikke længere udbetales i denne lønkørsel: {travels}. De er allerede udbetalt i en anden kørsel eller er ikke godkendt. Fjern dem fra udkastet, eller tilbagefør den kørsel, der udbetalte dem.',
  'err.payroll.travelNotPayable': 'En rejseafregning eller et udlæg i lønkørslen er allerede udbetalt i en anden kørsel eller er ikke længere godkendt. Fjern linjen fra udkastet, før du godkender.',
  'pay.noCalculationBasis': 'Intet beregningsgrundlag',
  'pay.payTypeGroup.common': 'Almindelige',
  'pay.payTypeGroup.custom': 'Egne lønarter',
  'pay.payTypeGroup.other': 'Andre lønarter',
  'pay.payTypeGroup.benefitInKind': 'Naturalieydelser',
  'pay.payTypeGroup.deduction': 'Træk',
  'pay.payTypeGroup.taxFreeAllowance': 'Skattefri godtgørelser',
  'pay.inactive': 'inaktiv',
  'pay.selectSalaryType': 'Vælg lønart',
  'pay.searchSalaryTypeOrRule': 'Søg efter lønart eller regel',
  'pay.showMoreSalaryTypes': 'Vis flere lønarter',
  'pay.calculationRules': 'Beregningsregler',
  'pay.agaAndTaxTab': 'Arbejdsgiverafgift og skat',
  'pay.pensionOtpTab': 'Pension/OTP',
  'pay.zone': 'Zone',
  'pay.status.paid': 'Betalt',
  'pay.status.unpaid': 'Ikke betalt',
  'pay.status.approved': 'Godkendt',
  'pay.status.annulled': 'Annulleret',
  'pay.status.draft': 'Udkast',
  'pay.status.partiallyPaid': 'Delvist betalt',
  'pay.select': 'Vælg',
  'pay.search': 'Søg',
  'pay.noDataYet': 'Ingen data endnu',
  'pay.noDataYetBody': 'Når der er registreringer, vises de her.',
  'pay.notSet': 'Ikke angivet',
  'pay.thisIsADeduction': 'Dette er et træk',
  'pay.fixedLineHint.payout': 'Linjen udbetales til medarbejderen',
  'pay.fixedLineHint.taxable': 'Trækpligtig - indgår i forskudstrækket',
  'pay.fixedLineHint.employerContribution': 'Indgår i grundlaget for arbejdsgiverafgift',
  'pay.fixedLineHint.holidayPay': 'Indgår i feriepengegrundlaget',
  'pay.fixedLineHint.pension': 'Indgår i grundlaget for pension (OTP)',
  'pay.fixedLineHint.deduction': 'Negativt beløb - trækkes fra udbetalingen',
  'pay.amountMustBePositive': 'Beløbet skal være større end 0.',
  'pay.amountExceedsOpenTerm': 'Beløbet må ikke være højere end det, der står åbent på terminen.',
  'pay.allocationMustMatchAmount': 'Fordelingen skal svare til beløbet og må ikke overstige åbne beløb.',
  'pay.paymentUpdated': 'Betaling opdateret.',
  'pay.paymentRegistered': 'Betaling registreret.',
  'pay.savePaymentFailed': 'Kunne ikke gemme betaling.',
  'pay.paymentAnnulled': 'Betaling annulleret.',
  'pay.annulPaymentFailed': 'Kunne ikke annullere betaling.',
  'pay.allPensionPaymentsRegistered': 'Alle pensionsindbetalinger er registreret.',
  'pay.noOtpToRegisterYet': 'Ingen beregnet OTP at registrere endnu.',
  'pay.missingPayrollRunForOtp': 'Mangler lønkørsel for OTP-betalingen.',
  'pay.pensionPaymentRegistered': 'Pensionsbetaling registreret.',
  'pay.registerPensionPaymentFailed': 'Kunne ikke registrere pensionsbetaling.',
  'pay.explainRuleOverrideRequired': 'Begrund, hvorfor beregningsreglerne tilsidesættes.',
  'pay.navRefundsFetched': 'NAV-refusioner hentet.',
  'pay.navRefundsFetchFailed': 'Kunne ikke hente refusioner fra NAV.',
  'pay.payslipDownloaded': 'Lønseddel downloadet.',
  'pay.payslipDownloadFailed': 'Kunne ikke downloade lønseddel.',
  'pay.payslipsDownloaded': 'Lønsedler downloadet.',
  'pay.payslipsDownloadFailed': 'Kunne ikke downloade lønsedler.',
  'pay.paymentInfoCopied': 'Udbetalingsoplysninger kopieret.',
  'pay.paymentFileDownloaded': 'Udbetalingsfil downloadet.',
  'pay.linkInboxDocumentFailed': 'Kunne ikke tilknytte bilag fra indbakken.',
  'pay.payrollRunCreated': 'Lønudbetaling oprettet.',
  'pay.payrollRunCreateFailed': 'Kunne ikke oprette lønudbetaling.',
  'pay.payrollRunUpdateFailed': 'Kunne ikke opdatere lønudbetalingen.',
  'pay.deletedPayrollRunRemoved': 'Slettet lønudbetaling fjernet.',
  'pay.removePayrollRunFailed': 'Kunne ikke fjerne lønudbetalingen.',
  'pay.commentSaved': 'Kommentar gemt.',
  'pay.salaryLineAdded': 'Lønlinje tilføjet.',
  'pay.voucherLinkedToPayrollRun': 'Bilag knyttet til lønudbetalingen.',
});
